import { useCallback } from 'react';
import PropTypes from 'prop-types';
import { Box, Checkbox, ExternalLink, NakedButton, Label } from '@qga/roo-ui/components';
import { TERMS_AND_CONDITIONS_URL, PRIVACY_AND_SECURITY_URL } from 'config/constants';

const TermsAndConditionsAgreement = ({
  onClickCancellationPolicy,
  onAcceptTermsChange,
  onTermsAndConditionsClick,
  onPrivacyAndSecurityClick,
  ...styleProps
}) => {
  const toggleTermsAccepted = useCallback(
    (event) => {
      onAcceptTermsChange(event.target.checked);
    },
    [onAcceptTermsChange],
  );
  const onKeyDown = useCallback(
    (event) => {
      if (event.key === 'Enter') {
        event.target.checked = !event.target.checked;
        onAcceptTermsChange(event.target.checked);
      }
    },
    [onAcceptTermsChange],
  );

  return (
    <Box {...styleProps}>
      <Label textStyle="terms-and-conditions" mb={0}>
        <Checkbox name="accept-terms-and-conditions" onKeyDown={onKeyDown} onChange={toggleTermsAccepted} />I agree to{' '}
        <ExternalLink underline href={TERMS_AND_CONDITIONS_URL} onClick={onTermsAndConditionsClick}>
          terms & conditions
        </ExternalLink>
        ,{' '}
        <NakedButton textDecoration="underline" onClick={onClickCancellationPolicy}>
          hotel cancellation policy
        </NakedButton>{' '}
        and{' '}
        <ExternalLink underline href={PRIVACY_AND_SECURITY_URL} onClick={onPrivacyAndSecurityClick}>
          privacy policy
        </ExternalLink>
        .
      </Label>
    </Box>
  );
};

TermsAndConditionsAgreement.propTypes = {
  onClickCancellationPolicy: PropTypes.func.isRequired,
  onAcceptTermsChange: PropTypes.func.isRequired,
  onTermsAndConditionsClick: PropTypes.func,
  onPrivacyAndSecurityClick: PropTypes.func,
};

export default TermsAndConditionsAgreement;
